import React from "react";
import { styled } from "@mui/material/styles";
import { InversionSolutionQuery$data } from "./__generated__/InversionSolutionQuery.graphql";
import { Button, Container, Typography } from "@mui/material";
import { formatBytes, formatDate } from "../../utils/utils";
import KeyValueTable from "../../components/common/KeyValueTable";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";

export interface InversionSolutionDetailTabProps {
  data: InversionSolutionQuery$data | null | undefined;
}

const TabContainer = styled(Container)(() => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "left",
}));

const InversionSolutionDetailTab: React.FC<InversionSolutionDetailTabProps> = ({
  data,
}: InversionSolutionDetailTabProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const solution = data?.node as any;
  const meta = data?.node?.__typename !== "%other" && data?.node?.meta;

  // console.log("InversionSolutionDetailTab:", solution)

  if (solution?.__typename === "%other") {
    return <div>Other</div>;
  }
  return (
    <TabContainer>
      <Typography>
        <strong>Created: </strong>
        {formatDate(solution?.created)}
      </Typography>
      <Typography>
        <strong>File Name: </strong>
        {solution?.file_name}
      </Typography>
      <Typography>
        <strong>File Size: </strong>
        {formatBytes(solution?.file_size)}
      </Typography>
      <Typography>
        <strong>MD5 Digest: </strong>
        {solution?.md5_digest}
      </Typography>
      {solution?.produced_by && (
        <Typography>
          <strong>Produced By: </strong>
          <Link to={viewPath(solution?.produced_by?.id)}>{solution.produced_by?.id}</Link>
        </Typography>
      )}
      {solution?.source_solution && (
        <Typography>
          <strong>Source Solution: </strong>
          <Link to={viewPath(solution?.source_solution?.id)}>{solution.source_solution?.id}</Link>
        </Typography>
      )}
      {solution?.common_rupture_set?.id && (
        <Typography>
          <strong>Common Rupture Set: </strong>
          <Link to={viewPath(solution?.common_rupture_set?.id)}>{solution.common_rupture_set?.id}</Link>
        </Typography>
      )}
      {solution?.aggregation_fn && (
        <Typography>
          <strong>Aggregation Function: </strong>
          {solution.aggregation_fn}
        </Typography>
      )}

      <Button href={solution?.file_url || ""}>Download</Button>
      {meta && <KeyValueTable header="Meta" data={meta} />}
    </TabContainer>
  );
};

export default InversionSolutionDetailTab;
